module.exports = __webpack_public_path__ + "images/vbk_calc.png?66446daa4b47f042874409c865852b31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vbk_calc.png
// module id = c1cI
// module chunks = 0